import Vue from 'vue'
import Router from 'vue-router'
import Profile from '@/components/Profile'

import PlaceList from '@/components/Place/PlaceList'
// import PlaceForm from '@/components/Place/PlaceForm'
// import PlaceView from '@/components/Place/PlaceView'
import PlaceAssign from '@/components/Place/PlaceAssign'

import ChargerList from '@/components/Charger/ChargerList'
// import ChargerForm from '@/components/Charger/ChargerForm'
// import ChargerView from '@/components/Charger/ChargerView'
import ChargerAssign from '@/components/Charger/ChargerAssign'
import ChargerChart from '@/components/Charger/ChargerChart'
import ChargerStatus from '@/components/Charger/ChargerStatus'
import ChargerReport from '@/components/Charger/ChargerReport'

import CheckerList from '@/components/Checker/CheckerList'
// import CheckerForm from '@/components/Checker/CheckerForm'
// import CheckerView from '@/components/Checker/CheckerView'

import ReportList from '@/components/Report/ReportList'
// import ReportForm from '@/components/Report/ReportForm'
// import ReportView from '@/components/Report/ReportView'
// import ReportContent from '@/components/Report/ReportContent'
import ReportMonthly from '@/components/Report/ReportMonthly'
import ReportDownload from '@/components/Report/ReportDownload'

import PlugList from '@/components/Plug/PlugList'
// import PlugView from '@/components/Plug/PlugView'
import PlugAssign from '@/components/Plug/PlugAssign'
import PlugReportList from '@/components/Plug/PlugReportList'

import Assignment from '@/components/Assignment'
// import Map from '@/components/Map'

import DatabaseMigration from '@/components/Admin/DatabaseMigration'
import ReportMonthlyAttendance from '@/components/Report/Attendance/ReportMonthlyAttendance'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: ChargerStatus
    },
    {
      path: '/Profile',
      name: 'Profile',
      component: Profile
    },
    /*
    {
      path: '/Map',
      name: 'Map',
      component: Map
    },
    */
    {
      path: '/Chargers/chart',
      name: 'ChargerChart',
      component: ChargerChart
    },
    {
      path: '/Chargers/status',
      name: 'ChargerStatus',
      component: ChargerStatus
    },
    {
      path: '/Chargers/report',
      name: 'ChargerReport',
      component: ChargerReport
    },
    {
      path: '/Assignment',
      name: 'Assignment',
      component: Assignment
    },
    {
      path: '/Places',
      name: 'PlaceList',
      component: PlaceList
    },
    /*
    {
      path: '/Places/add',
      name: 'PlaceAdd',
      component: PlaceForm
    },
    {
      path: '/Places/:id',
      name: 'PlaceView',
      component: PlaceView,
      props: true
    },
    {
      path: '/Places/:id/edit',
      name: 'PlaceEdit',
      component: PlaceForm,
      props: true
    },
    */
    {
      path: '/Places/assign',
      name: 'PlaceAssign',
      component: PlaceAssign
    },
    {
      path: '/Chargers',
      name: 'ChargerList',
      component: ChargerList
    },
    /*
    {
      path: '/Chargers/add',
      name: 'ChargerAdd',
      component: ChargerForm
    },
    {
      path: '/Chargers/:id',
      name: 'ChargerView',
      component: ChargerView,
      props: true
    },
    {
      path: '/Chargers/:id/edit',
      name: 'ChargerEdit',
      component: ChargerForm,
      props: true
    },
    */
    {
      path: '/Chargers/assign',
      name: 'ChargerAssign',
      component: ChargerAssign
    },
    {
      path: '/Checkers',
      name: 'CheckerList',
      component: CheckerList
    },
    /*
    {
      path: '/Checkers/add',
      name: 'CheckerAdd',
      component: CheckerForm
    },
    {
      path: '/Checkers/:id',
      name: 'CheckerView',
      component: CheckerView,
      props: true
    },
    {
      path: '/Checkers/:id/edit',
      name: 'CheckerEdit',
      component: CheckerForm,
      props: true
    },
    */
    {
      path: '/Reports',
      name: 'ReportList',
      component: ReportList
    },
    /*
    {
      path: '/Reports/add',
      name: 'ReportAdd',
      component: ReportForm
    },
    {
      path: '/Reports/:id',
      name: 'ReportView',
      component: ReportView
    },
    {
      path: '/ReportContents',
      name: 'ReportContents',
      component: ReportContent
    },
    */
    {
      path: '/Reports/monthly/:kind',
      name: 'ReportMonthly',
      component: ReportMonthly,
      props: true
    },
    {
      path: '/Reports/download',
      name: 'ReportDownload',
      component: ReportDownload
    },
    {
      path: '/Plugs',
      name: 'PlugList',
      component: PlugList
    },
    /*
    {
      path: '/Plugs/:id',
      name: 'PlugView',
      component: PlugView,
      props: true
    },
    */
    {
      path: '/Plugs/assign',
      name: 'PlugAssign',
      component: PlugAssign
    },
    {
      path: '/Plugs/reports',
      name: 'PlugReportList',
      component: PlugReportList
    },
    {
      path: '/Admin/DatabaseMigration',
      name: 'DatabaseMigration',
      component: DatabaseMigration
    },
    {
      path: '/Attendance/ReportMonthlyAttendance',
      name: 'ReportMonthlyAttendance',
      component: ReportMonthlyAttendance
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js